import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./index.css";

import NewArrivalsCard from "./NewArrivalsCard";

const NewArrivals = ({
  t,
  sectionRef,
  homePageSearchedResultProducts,
  vendor_name,
}) => {
  const [newArrivalProducts, setnewArrivalProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/products?category=&vendor_name=${vendor_name}`)
      .then((response) => response.json())
      .then((data) => {setnewArrivalProducts(data); setLoading(false);});
    
  }, [vendor_name]);

  let productsToShow = (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <h3>Loading Products...</h3>
    </div>
  );
  
  let heading = (
    <div className="section-header">
      <h1 className="section-title">{t("NewArrivals")}</h1>
      <div className="section-subtitle">Discover our latest collection</div>
    </div>
  );

  if (homePageSearchedResultProducts && homePageSearchedResultProducts.length) {
    productsToShow = homePageSearchedResultProducts.map((product, index) => (
      <div key={product.id || index} className="product-item">
        <NewArrivalsCard
          productObj={product}
          title={product.name}
          price={`৳${product.price}`}
          image={product.photo}
          t={t}
        />
      </div>
    ));

    heading = (
      <div className="section-header">
        <h1 className="section-title">Search Results</h1>
        <div className="section-subtitle">
          Found {homePageSearchedResultProducts.length} products
        </div>
      </div>
    );
  } else if (newArrivalProducts.length) {
    productsToShow = newArrivalProducts.slice(0, 20).map((product, index) => (
      <div key={product.id || index} className="product-item">
        <NewArrivalsCard
          productObj={product}
          title={product.name}
          price={`৳${product.price}`}
          image={product.photo}
          t={t}
        />
      </div>
    ));
  } else if(!loading) {
    productsToShow = (
      <div className="no-products-container">
        <div className="no-products-icon">📦</div>
        <h3>No Products Available</h3>
        <p>Check back later for new arrivals</p>
      </div>
    );
  }

  return (
    <section className="new-arrivals-section">
      <div className="container">
        {heading}
        <div ref={sectionRef} className="products-grid">
          {productsToShow}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    vendor_name: state.globalState.selectedProductVendorName,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewArrivals);